import { useContext, useEffect, useState } from "react";

import { regexService, templateService } from "../../service";

import { loaderContext, notificationContext } from "../../context/context";
import { Modal } from "../../components";
import { useModal } from "../../hooks";
import dateFormat from "../../utils/dateFormat";

function SMSList() {
  const toast = useContext(notificationContext);
  const { isModal, showModal, hideModal } = useModal();

  const [isLoading, setLoading] = useState(true);

  const [smsTemplate, setSMSTemplate] = useState([]);
  const [templateData, setTemplateData] = useState();

  const [searchValue, setSearchValue] = useState("");
  const [searchList, setSearchList] = useState([]);

  const getSMSTemplate = async () => {
    const response = await templateService.getSMSTemplates();

    if (response.error) {
      if (response.error.code !== 101) {
        toast.error(response?.error?.message);
      }
    } else {
      setSMSTemplate(response.data);
      setSearchList(response.data);
    }
    setLoading(false);
  };

  const onRowItemClick = (rowData = null) => {
    showModal();
    setTemplateData(rowData);
  };

  const handleSearch = () => {
    setLoading(true);
    if (searchValue?.length == 0) {
      setSearchList(smsTemplate);
      return;
    }
    const data =
      smsTemplate?.filter((e) =>
        (e.template_name
          ?.toString()
          ?.toUpperCase()
          .match(searchValue?.toUpperCase())||e.purpose_descs
          ?.toString()
          ?.toUpperCase()
          .match(searchValue?.toUpperCase()))
      ) || [];
    setSearchList(data);
    setLoading(false);
  };

  useEffect(() => {
    if (searchValue?.length == 0) {
      setSearchList(smsTemplate);
    }
  }, [searchValue]);

  useEffect(() => {
    getSMSTemplate();
  }, []);

  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <h5>
          SMS Templates {smsTemplate?.length > 0 && `(${smsTemplate.length})`}
        </h5>
        {/* <button
          className="btn--sm btn-primary"
          onClick={() => navigate("createsmstemplate")}
        >
          Create Template
        </button> */}
      </div>
      <div className="mt-2">
        <div className="fc-nowrap flex-center justify-content-between mt-4">
          <label className="input input--sm fc-4">
            <input
              type="text"
              id="searchvalue"
              placeholder="Search by Template Name/Purpose of payment"
              value={searchValue}
              onChange={(e) =>
                regexService.isAlphanNumWithChar(e.target.value) &&
                setSearchValue(e.target.value)
              }
            />
            <button
              className="btn--xs btn-primary"
              onClick={() => {
                handleSearch();
              }}
            >
              <span class="material-symbols-rounded">search</span>
            </button>
          </label>
        </div>
        <div className="cover border rounded-border-sm  mt-3">
          <table>
            <thead>
              <tr>
                <th>Template Name</th>
                <th>Template ID</th>
                <th>Purpose of Payment</th>
                <th>Created By</th>
                <th>Created on</th>
              </tr>
            </thead>
            {searchList?.length > 0 && (
              <tbody className="table-body">
                {searchList?.map((data) => (
                  <tr>
                    <td
                      className="f-500 cursor-pointer"
                      onClick={() => onRowItemClick(data)}
                    >
                      {data.template_name}
                    </td>
                    <td>{data.template_id}</td>
                    <td>{data?.purpose_desc}</td>
                    <td>{data.createdby}</td>
                    <td>{dateFormat(data.createddt)}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
          {(isLoading && <div className="no-records">Loading...</div>) ||
            (searchList?.length == 0 && (
              <div className="no-records">No Records to display</div>
            ))}
        </div>
      </div>
      {isModal && (
        <Modal>
          <div className="side-modal modal--sm">
            <div className="modal-head border-bottom">
              <h6>Template Details</h6>
              <div className="icon" onClick={hideModal}>
                <span class="material-symbols-rounded">close</span>
              </div>
            </div>
            <div className="modal-body py-3">
              <div className="input-wrapper">
                <h6>{templateData?.template_name}</h6>
                <p className="text-2 text-secondary mt-1">
                  <span>ID : </span>
                  {templateData?.template_id}
                </p>
              </div>
              <div className="input-wrapper fc">
                <p className="title">Purpose of Payment</p>
                <p>{templateData?.purpose_desc}</p>
              </div>
              <div className="input-wrapper fc">
                <p className="title">Sender ID</p>
                <p>{templateData?.smsfrom}</p>
              </div>
              <div className="flex flex-wrap justify-content-between">
                <div className="input-wrapper fc-5">
                  <p className="title">Unicode</p>
                  <p>{templateData?.smsunicode}</p>
                </div>
                {templateData?.feedid && (
                  <div className="input-wrapper fc-5">
                    <p className="title">Feed ID</p>
                    <p>{templateData?.feedid}</p>
                  </div>
                )}
                {templateData?.dltPrincipalEntityId && (
                  <div className="input-wrapper fc-5">
                    <p className="title">DLT ID</p>
                    <p>{templateData?.dltPrincipalEntityId}</p>
                  </div>
                )}
                {templateData?.dltContentId && (
                  <div className="input-wrapper fc-5">
                    <p className="title">DLT Content ID</p>
                    <p>{templateData?.dltContentId}</p>
                  </div>
                )}
              </div>
              <hr />
              <div className="input-wrapper">
                <p className="title">SMS Template</p>
                <div className="cover p-2 bg-200">
                  <pre>{templateData?.smstext}</pre>
                </div>
              </div>
              <div className="input-wrapper">
                <p className="title">Dynamic Params</p>
                {templateData?.params &&
                  Object.keys(templateData.params)?.map(
                    (e) =>
                      templateData.params[e] && (
                        <div className="input-wrapper">
                          <span className="f-500">{e}</span> -{" "}
                          {templateData.params[e]}
                        </div>
                      )
                  )}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default SMSList;

const datadata=[
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "Re-Schedulement Charges",
      "smsunicode": "false",
      "purpose_id": "PRP001",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer,\n You can make a payment towards Re-Schedulement Charges for an amount of Rs.${param1} towards your ABHFL Loan A/C no. ${param2}. Click on the below link to make your payment now:\n ${param3}\n \n In case of any queries, please reach out to us at care.housingfinance@adityabirlacapital.com or call us at 18002707000.\n \n Regards, -Aditya Birla Housing Finance Limited",
      "template_name": "Re-Schedulement Charges",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template001",
      "dltContentId": "1107169502941174929",
      "username": "8422979504"
  },
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "Bounce Charges",
      "smsunicode": "false",
      "purpose_id": "PRP002",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer,\r  You can make a payment towards Bounce Charges for an amount of Rs.${param1} towards your ABHFL Loan A/C no. ${param2}. Click on the below link to make your payment now:\r  ${param3}\r  \r  In case of any queries, please reach out to us at care.housingfinance@adityabirlacapital.com or call us at 18002707000.\r  \r  Regards, -Aditya Birla Housing Finance Limited",
      "template_name": "Bounce Charges",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template002",
      "dltContentId": "1107169502941174929",
      "username": "8422979504"
  },
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "Copy of Collateral Documents Charges",
      "smsunicode": "false",
      "purpose_id": "PRP003",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer,\n You can make a payment towards Copy of Collateral Documents Charges for an amount of Rs.${param1} towards your ABHFL Loan A/C no. ${param2}. Click on the below link to make your payment now:\n ${param3}\n \n In case of any queries, please reach out to us at care.housingfinance@adityabirlacapital.com or call us at 18002707000.\n \n Regards, -Aditya Birla Housing Finance Limited",
      "template_name": "Copy of Collateral Documents Charges",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template003",
      "dltContentId": "1107169502941174929",
      "username": "8422979504"
  },
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "Foreclosure Statement Issuance Charges",
      "smsunicode": "false",
      "purpose_id": "PRP004",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer,\n You can make a payment towards Foreclosure Statement Issuance Charges for an amount of Rs.${param1} towards your ABHFL Loan A/C no. ${param2}. Click on the below link to make your payment now:\n ${param3}\n \n In case of any queries, please reach out to us at care.housingfinance@adityabirlacapital.com or call us at 18002707000.\n \n Regards, -Aditya Birla Housing Finance Limited",
      "template_name": "Foreclosure Statement Issuance Charges",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template004",
      "dltContentId": "1107169502941174929",
      "username": "8422979504"
  },
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "ROI Switch Fees",
      "smsunicode": "false",
      "purpose_id": "PRP005",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer,\r You can make a payment towards ROI Switch Fees for an amount of Rs.${param1} towards your ABHFL Loan A/C no. ${param2}. Click on the below link to make your payment now:\r  ${param3}\r  \r  In case of any queries, please reach out to us at care.housingfinance@adityabirlacapital.com or call us at 18002707000.\r  \r  Regards, -Aditya Birla Housing Finance Limited",
      "template_name": "ROI Switch Fees",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template005",
      "dltContentId": "1107169502941174929",
      "username": "8422979504"
  },
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "Duplicate NOC Copy Charges",
      "smsunicode": "false",
      "purpose_id": "PRP006",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer,\nYou can make a payment towards Duplicate NOC Copy Charges for an amount of Rs.${param1} towards your ABHFL Loan A/C no. ${param2}. Click on the below link to make your payment now:\n ${param3}\n \n In case of any queries, please reach out to us at care.housingfinance@adityabirlacapital.com or call us at 18002707000.\n \n Regards, -Aditya Birla Housing Finance Limited",
      "template_name": "Duplicate NOC Copy Charges",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template006",
      "dltContentId": "1107169502941174929",
      "username": "8422979504"
  },
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "NACH Swap Charges",
      "smsunicode": "false",
      "purpose_id": "PRP007",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer,\nYou can make a payment towards NACH Swap Charges for an amount of Rs.${param1} towards your ABHFL Loan A/C no. ${param2}. Click on the below link to make your payment now:\n ${param3}\n \n In case of any queries, please reach out to us at care.housingfinance@adityabirlacapital.com or call us at 18002707000.\n \n Regards, -Aditya Birla Housing Finance Limited",
      "template_name": "NACH Swap Charges",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template007",
      "dltContentId": "1107169502941174929",
      "username": "8422979504"
  },
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "Loan Overdue Payment",
      "smsunicode": "false",
      "purpose_id": "PRP008",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer,\nYou can make a payment towards Shortfall of Foreclosure for an amount of Rs.${param1} towards your ABHFL Loan A/C no. ${param2}. Click on the below link to make your payment now:\n ${param3}\n \n In case of any queries, please reach out to us at care.housingfinance@adityabirlacapital.com or call us at 18002707000.\n \n Regards, -Aditya Birla Housing Finance Limited",
      "template_name": "Shortfall of Foreclosure",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template008",
      "dltContentId": "1107169502941174929",
      "username": "8422979504"
  },
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "Shortfall of Foreclosure",
      "smsunicode": "false",
      "purpose_id": "PRP009",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer, \nYour EMI of Rs.${param1} towards your ABHFL Loan A/C no. ${param2} is overdue. \nKindly clear the dues immediately by clicking on following link:\n${param3}\n\nIn case of any queries, feel free to reach out to us at care.housingfinance@adityabirlacapital.com or contact us at 18002707000.\n\nRegards,\nAditya Birla Housing Finance Limited",
      "template_name": "Loan Overdue Payment",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template009",
      "dltContentId": "1107169502941174929",
      "username": "8422979504"
  },
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "EMI & Charges",
      "smsunicode": "false",
      "purpose_id": "PRP012",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer,\nYour EMI & Charges of Rs. ${param1} towards your ABHFL Loan A/C no. ${param2} is overdue.\nKindly clear the dues immediately by clicking on this link:\n${param3} In case of any queries, feel free to reach out to us at care.housingfinance@adityabirlacapital.com or contact us at 18002707000.\nRegards, -Aditya Birla Housing Finance Limited",
      "template_name": "ABHFL_EMI & Charges",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template010",
      "dltContentId": "1107169339662635336",
      "username": "8422979504"
  },
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "Penalty charges",
      "smsunicode": "false",
      "purpose_id": "PRP010",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer,\nPenalty charges of Rs. ${param1} towards your ABHFL Loan A/C no. ${param2} is overdue.\nKindly clear the dues immediately by clicking on this link:\n${param3} In case of any queries, feel free to reach out to us at care.housingfinance@adityabirlacapital.com or contact us at 18002707000. Regards -Aditya Birla Housing Finance Limited",
      "template_name": "ABHFL_Charges",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template011",
      "dltContentId": "1107169339659209547",
      "username": "8422979504"
  },
  {
      "dltPrincipalEntityId": "",
      "merc_id": "MRC0001",
      "purpose_desc": "EMI",
      "smsunicode": "false",
      "purpose_id": "PRP011",
      "params": {
          "param7": "",
          "param8": "",
          "param5": "",
          "param6": "",
          "param9": "",
          "param10": "",
          "param3": "link",
          "param4": "",
          "param1": "dueamount",
          "param2": "lannumber"
      },
      "smstext": "Dear Customer,\nYour EMI of Rs. ${param1} towards your ABHFL Loan A/C no. ${param2} is overdue.\nKindly clear the dues immediately by clicking on following link:\n${param3} In case of any queries, feel free to reach out to us at care.housingfinance@adityabirlacapital.com or contact us at 18002707000.\nRegards, -Aditya Birla Housing Finance Limited",
      "template_name": "ABHFL_EMI",
      "password": "Abhfl%402021",
      "smsfrom": "ABCDLT",
      "createddt": "2023-08-29T00:00",
      "createdby": "admin1",
      "template_id": "template012",
      "dltContentId": "1107168691047081527",
      "username": "8422979504"
  }
]